// extracted by mini-css-extract-plugin
export default {"wrapper":"intentions_wrapper__RxMu1","image":"intentions_image__XZbDM","inside":"intentions_inside__Pv8Dx"};